import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center space-x-2 py-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Đơn giá ")
], -1)
const _hoisted_3 = { class: "d-flex align-items-center justify-content-end mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_FormModalShell = _resolveComponent("FormModalShell")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createBlock(_component_FormModalShell, {
    "is-display": _ctx.isOpen,
    title: _ctx.labelDisplay,
    size: "xl",
    onClose: _ctx.onClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.SAVE,
        "color-type": _ctx.ButtonTypeColors.SUCCESS,
        onClick: _ctx.submit
      }, {
        "button-label": _withCtx(() => [
          _createTextVNode("Lưu")
        ]),
        _: 1
      }, 8, ["button-type", "color-type", "onClick"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
            default: _withCtx(() => [
              _createTextVNode("Tìm kiếm")
            ]),
            _: 1
          }),
          _createVNode(_component_el_input, {
            modelValue: _ctx.searchTerm,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            class: "w-56",
            placeholder: "Tìm theo mã hoặc tên",
            onInput: _ctx.searchForVatTu
          }, null, 8, ["modelValue", "onInput"])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          style: {"width":"100%"},
          "max-height": "550",
          "empty-text": "Đang hiển thị danh sách vật tư",
          size: "medium",
          "cell-class-name": _ctx.isTextDangerColumn,
          border: true,
          data: _ctx.vatTuItems
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { width: "55" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.selectedVatTuIdArr[scope.$index],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.selectedVatTuIdArr[scope.$index]) = $event),
                  onChange: 
                (value) =>
                  _ctx.onChangeVatTuCheckbox({
                    row: scope.row,
                    value,
                  })
              
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "ID",
              width: "50"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Tên" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.ten_vat_tu), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Mã" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.ma_vat_tu), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Thu hồi" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.vatTuItems[scope.$index].thu_hoi,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].thu_hoi) = $event),
                  disabled: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "C/ty quản lý" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.vatTuItems[scope.$index].cong_ty_duyet,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].cong_ty_duyet) = $event),
                  disabled: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Trạng thái",
              width: "90"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.isValidLabel(scope.row)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, null, {
              header: _withCtx(() => [
                _hoisted_2
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_3, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatUnitPrice(scope.row.don_gia)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Đơn vị tính" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.don_vi_tinh), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["cell-class-name", "data"])), [
          [_directive_loading, _ctx.isTableLoading]
        ]),
        (_ctx.vatTuItems.length > 0)
          ? (_openBlock(), _createBlock(_component_Pagination, {
              key: 0,
              page: _ctx.currentPage,
              "page-size": 20,
              total: _ctx.totalItems,
              "show-per-page": false,
              onChangePage: _cache[1] || (_cache[1] = (value) => (_ctx.currentPage = value))
            }, null, 8, ["page", "total"]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_dialog_auto_focus, _ctx.isOpen]
      ])
    ]),
    _: 1
  }, 8, ["is-display", "title", "onClose"]))
}